module.exports = __webpack_public_path__ + "static/Paragraph_01-e4a2af6f18e6c4d6875206dbbcf3e678.jpg";